import React from 'react';
import './Hero.css';
import Button from '../../components/Button';

export const Hero = ({ title, description, buttonLabel }) => {
  return <div className="hero">
    <h1>{title}</h1>
    <p>{description}</p>
    <Button label={buttonLabel} type='secondary' className="hero-button" />
  </div>;
};
